
export default function useScriptsToRoute(currentRoute: string) {
  let useMgid = true;
  let useGpt = true;
  let useMarfeel = true;
  let useGtm = true;
  let useNavbar = true;
  let useComscore = true;
  let useFullScreen = false;
  let useRun = true;
  let useTeads = false;
  let specifyId = undefined;

  const autoEditorial = ['veiculos', 'carros', 'mobilidade-urbana', 'veiculos-autonomos'];

  // /carros/hilux-2026-flagra-mostra-mudanca-radical-na-picape-da-toyota/
  const routeParts = currentRoute.split('/').filter(Boolean);
  const category = routeParts[0];
  const isArticleRoute = routeParts.length > 1;
  const isAutoEditorialCategory = autoEditorial.includes(category) && isArticleRoute;

  if (isAutoEditorialCategory) {
    useTeads = true;
  }

  switch (currentRoute) {
      case '/guia-de-compras':
        useMgid = false;
        useGpt = false;
        useMarfeel = false;
        useComscore = false;

        useNavbar = false;
        useFullScreen = true;
        useRun = false;

        specifyId = 'GTM-PT37RWSC';
        break;
      case '/live':
        useMgid = false;
        useGpt = false;
        useMarfeel = false;
        useComscore = false;

        useNavbar = false;
        useFullScreen = true;
        useRun = false;

        specifyId = 'GTM-K9569WH2';
        break;
      default:
        break;
    }

  return {
    useMgid: useMgid,
    useGpt: useGpt,
    useMarfeel: useMarfeel,
    useTeads: useTeads,
    useGtm: useGtm,
    specifyId: specifyId,
    useNavbar: useNavbar,
    useComscore: useComscore,
    useRun: useRun,
    useFullScreen: useFullScreen,
  };
}
